import React from 'react';

const RotationReport = ({ highestRotationProducts, lowestRotationProducts, reportParams }) => {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
      <div>
        <div style={{ border: '1px solid var(--border)', borderRadius: '0.375rem', backgroundColor: 'var(--card-bg)' }}>
          <div style={{ padding: '0.5rem', backgroundColor: 'var(--bg)', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h5 style={{ margin: 0, fontSize: '0.9rem', fontWeight: '600' }}>🔄 Najbardziej rotujące produkty</h5>
            <small style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>Top {reportParams.limit}</small>
          </div>
          <div style={{ padding: '0.75rem' }}>
            {highestRotationProducts.length > 0 ? (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.75rem' }}>
                  <thead>
                    <tr>
                      <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Ranking</th>
                      <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Produkt</th>
                      <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Sprzedano</th>
                      <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Dziennie</th>
                      <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>%</th>
                    </tr>
                  </thead>
                  <tbody>
                    {highestRotationProducts.map((product) => (
                      <tr key={product.id}>
                        <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>
                          <span style={{ border: '1px solid var(--info)', color: 'var(--info)' , padding: '0.1rem 0.2rem', borderRadius: '0.2rem', fontSize: '0.6rem' }}>#{product.ranking}</span>
                        </td>
                        <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>
                          <div>
                            <div style={{ fontWeight: '600', fontSize: '0.65rem' }}>{product.nazwa}</div>
                            <div style={{ color: 'var(--text-muted)', fontSize: '0.6rem' }}>{product.kategoria_nazwa}</div>
                          </div>
                        </td>
                        <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>{product.total_quantity_sold}</td>
                        <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>{product.rotation_index}</td>
                        <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>
                          <span style={{ border: '1px solid var(--success)', color: 'var(--success)' , padding: '0.1rem 0.2rem', borderRadius: '0.2rem', fontSize: '0.6rem' }}>
                            {parseFloat(product.percentage_of_total_sales || 0).toFixed(1)}%
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div style={{ textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.8rem' }}>Brak danych</div>
            )}
          </div>
        </div>
      </div>

      <div>
        <div style={{ border: '1px solid var(--border)', borderRadius: '0.375rem', backgroundColor: 'var(--card-bg)' }}>
          <div style={{ padding: '0.5rem', backgroundColor: 'var(--bg)', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h5 style={{ margin: 0, fontSize: '0.9rem', fontWeight: '600' }}>🐌 Najmniej rotujące produkty</h5>
            <small style={{ fontSize: '0.7rem', color: 'var(--text-muted)' }}>Top {reportParams.limit}</small>
          </div>
          <div style={{ padding: '0.75rem' }}>
            {lowestRotationProducts.length > 0 ? (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.75rem' }}>
                  <thead>
                    <tr>
                      <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Produkt</th>
                      <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Problem</th>
                      <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Stan</th>
                      <th style={{ padding: '0.3rem', borderBottom: '1px solid var(--border)', textAlign: 'left', fontSize: '0.65rem' }}>Sprzedano</th>
                    </tr>
                  </thead>
                  <tbody>
                    {lowestRotationProducts.map((product) => (
                      <tr key={product.id}>
                        <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>
                          <div>
                            <div style={{ fontWeight: '600', fontSize: '0.65rem' }}>{product.nazwa}</div>
                            <div style={{ color: 'var(--text-muted)', fontSize: '0.6rem' }}>{product.kod_produktu}</div>
                          </div>
                        </td>
                        <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>
                          <span style={{
                            backgroundColor: product.issue === 'Brak sprzedaży' ? 'var(--danger)' :
                              product.issue === 'Bardzo niska rotacja' ? 'var(--warning)' : 'var(--text-muted)',
                            color: '#fff' ,
                            padding: '0.1rem 0.2rem',
                            borderRadius: '0.2rem',
                            fontSize: '0.6rem'
                          }}>
                            {product.issue}
                          </span>
                        </td>
                        <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>{product.stan_magazynowy || 0}</td>
                        <td style={{ padding: '0.25rem', borderBottom: '1px solid var(--bg)' }}>{product.total_quantity_sold || 0}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div style={{ textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.8rem' }}>Brak danych</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RotationReport;
